(() => {
  const root = document.querySelector('[data-embod-boots-page]');
  if (!root) return;

  const radios = [...root.querySelectorAll('[data-boots-variant]')];
  const variantInput = root.querySelector('[data-boots-variant-id]');
  const addButton = root.querySelector('[data-boots-add]');
  const addLabel = root.querySelector('[data-boots-add-label]');
  const mobileSelection = root.querySelector('[data-mobile-buy-selection]');

  const selectVariant = (radio) => {
    if (!radio || !variantInput || !addButton || !addLabel) return;
    variantInput.value = radio.value;
    const available = radio.dataset.available === 'true';
    addButton.disabled = !available;
    addLabel.textContent = available
      ? `Add ${radio.dataset.title} to cart · ${radio.dataset.price}`
      : `${radio.dataset.title} is unavailable`;
    if (mobileSelection) mobileSelection.textContent = `${radio.dataset.title} · ${radio.dataset.price}`;
  };

  radios.forEach((radio) => radio.addEventListener('change', () => selectVariant(radio)));
  selectVariant(radios.find((radio) => radio.checked) || radios[0]);

  root.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
    const count = gallery.querySelector('[data-gallery-count]');
    const dotsContainer = gallery.querySelector('[data-gallery-dots]');
    let index = 0;
    let touchStartX = null;

    const dots = slides.map((_, dotIndex) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'ebp-gallery-dot';
      dot.setAttribute('aria-label', `Show product image ${dotIndex + 1}`);
      dot.addEventListener('click', () => show(dotIndex));
      dotsContainer?.append(dot);
      return dot;
    });

    const show = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('ebp-is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (count) count.textContent = `${index + 1} / ${slides.length}`;
    };

    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => show(index - 1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(index + 1));
    gallery.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0]?.clientX ?? null;
    }, { passive: true });
    gallery.addEventListener('touchend', (event) => {
      if (touchStartX === null) return;
      const distance = (event.changedTouches[0]?.clientX ?? touchStartX) - touchStartX;
      if (Math.abs(distance) > 40) show(index + (distance < 0 ? 1 : -1));
      touchStartX = null;
    }, { passive: true });
    show(0);
  });

  root.querySelectorAll('[data-quantity-control]').forEach((control) => {
    const input = control.querySelector('input');
    control.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
      input.value = Math.max(1, Number(input.value || 1) - 1);
    });
    control.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
      input.value = Math.max(1, Number(input.value || 1) + 1);
    });
  });

  const mobileBar = root.querySelector('[data-mobile-buy-bar]');
  const sizeFieldset = root.querySelector('.ebp-variant-fieldset');
  const syncMobileBar = () => {
    if (!mobileBar || !addButton) return;
    const visible = window.innerWidth <= 580 && addButton.getBoundingClientRect().bottom < 84;
    mobileBar.classList.toggle('is-visible', visible);
    mobileBar.setAttribute('aria-hidden', String(!visible));
  };
  root.querySelector('[data-mobile-buy-scroll]')?.addEventListener('click', () => {
    sizeFieldset?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    window.setTimeout(() => (radios.find((radio) => radio.checked) || radios[0])?.focus(), 300);
  });
  window.addEventListener('scroll', syncMobileBar, { passive: true });
  window.addEventListener('resize', syncMobileBar);
  syncMobileBar();
})();
